module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<section class="pro-bottom-info">\r\n  <div class="mycontainer">\r\n    <div class="left wow fadeInLeft">鏈夐棶棰橈紵鎴戜滑闅忔椂鎻愪緵甯姪</div>\r\n    <div class="right wow fadeInRight">\r\n      <a href="questions.html?message=true"><i class="iconfont icon-zixunjilu1"></i>鍦ㄧ嚎鍜ㄨ</a>\r\n      <a href="questions.html?message=true"><i class="iconfont icon-renminbi"></i>鑾峰彇鎶ヤ环</a>\r\n      <a href="contact.html"><i class="iconfont icon-dianhua"></i>鑱旂郴鎴戜滑</a>\r\n    </div>\r\n  </div>\r\n</section>';

}
return __p
}